// extracted by mini-css-extract-plugin
export default {"DateWrapper":"FeedAdminToolsVersion2__DateWrapper__wudK_","DateClearButton":"FeedAdminToolsVersion2__DateClearButton__WybNW"};